export const faqs = [
    {
        id: 1,
        question: "How much do you charge?",
        answer: "mmh! For now lets just say I'm fair enough, and affordable. My services are value for money. So provide the project description and I will quote accordingly. "
    },
    {
        id: 2,
        question: "Do you do Graphic Design too?",
        answer: "Yes! I do branding for businesses and personal needs. I make logos, flyers, business cards and t-shirt prints."
    },
    {
        id: 3,
        question: "How long would it take you to complete my website?",
        answer: "I am quite fast. Depending on the features you want to implement, I will complete it within the shortest time possible"
    },
    {
        id: 4,
        question: "Can you handle maintenance of an existing website?",
        answer: "Yes! And even make it better than it is."
    }
]